import { Box, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { useGetUserQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import 'borrower/borrower.scss';
import { RouteTemplate } from 'packages/common-frontend/components/RouteTemplate';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { AssignmentLoadingSkeleton } from 'packages/loanProduct/ui/AssignmentSkeletonLoadingTables';
import { AssignmentEditStrategyContainer } from 'packages/loanProduct/ui/assignmentStrategy/AssignmentEditStrategyContainer';

export const SettingsAssignmentEditStrategyRoute = () => {
  const toast = useToast();
  const history = useHistory();

  let routeLevelError = false;

  const { data: userData, loading: userLoading } = useGetUserQuery();

  if (!userData || !userData.user || userLoading) {
    return (
      <AssignmentLoadingSkeleton dataTestId="loading-assignment-edit-route" />
    );
  }

  const {
    user: { organizationId },
  } = userData;

  return (
    <RouteTemplate>
      <Box className="main">
        <Sentry.ErrorBoundary
          onError={() => {
            if (!routeLevelError && !toast.isActive(errorToastId)) {
              errorToastConfig.title = `Failed to load assignment edit strategy route`;
              routeLevelError = true;
              toast(errorToastConfig);
              history.push('/');
            }
          }}
        >
          <AssignmentEditStrategyContainer
            organizationId={organizationId}
            readOnly={false}
          />
        </Sentry.ErrorBoundary>
      </Box>
    </RouteTemplate>
  );
};
